const redirectInsteadMenu = (e, path) => {
	e.preventDefault();
	window.open(path, '_blank');
};

export default redirectInsteadMenu;
